import {
    FormDetailComponent,
    FormDetailViewModelProps
} from "./FormDetail.component";
import { useFormDetailViewModel } from "./useFormDetail.viewmodel";

export function FormDetailScreen() {
    const vm: FormDetailViewModelProps = useFormDetailViewModel();
    return <FormDetailComponent {...vm} />;
}
